import * as React from 'react';
import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { ChevronDown } from 'lucide-react';
import { cn } from '@/lib/utils';
import { CardIcon } from './card';

const Accordion = React.forwardRef(({ className, ...props }, ref) => (
  <AccordionPrimitive.Root
    ref={ref}
    className={cn('c-accordion', 'flex flex-col gap-3', className)}
    {...props}
  />
));
Accordion.displayName = 'Accordion';

const AccordionItem = React.forwardRef(({ className, ...props }, ref) => (
  <AccordionPrimitive.Item
    ref={ref}
    className={cn('rounded-[8px] border border-solid border-neutral-lightest bg-white shadow-dropshadow-sm transition-shadow hover:shadow-[0px_4px_10px_rgba(68,43,140,0.08)]', className)}
    {...props}
  />
));
AccordionItem.displayName = 'AccordionItem';

const AccordionTrigger = React.forwardRef(({ className, children, ...props }, ref) => (
  <AccordionPrimitive.Header className="mb-0 flex">
    <AccordionPrimitive.Trigger
      ref={ref}
      className={cn(
        'c-accordion-trigger',
        // Estilo base
        'flex flex-1 items-center justify-between gap-3 transition-[color,background-color] duration-150 ease-out-strong',
        'text-left text-sm font-medium',
        '[&[data-state=open]_svg]:rotate-180',
        'px-5 py-3',
        className
      )}
      {...props}
    >
      {children}
      <CardIcon className="shrink-0 p-2">
        <ChevronDown className="size-4 transition-transform duration-200" />
      </CardIcon>
    </AccordionPrimitive.Trigger>
  </AccordionPrimitive.Header>
));
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName;

const AccordionContent = React.forwardRef(({ className, children, ...props }, ref) => (
  <AccordionPrimitive.Content
    ref={ref}
    className="overflow-hidden text-sm transition-[height,opacity] duration-200 ease-out-strong data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
    {...props}
  >
    <div className={cn('mx-5 border-t border-solid border-neutral-lightest px-0 py-5', className)}>{children}</div>
  </AccordionPrimitive.Content>
));

AccordionContent.displayName = AccordionPrimitive.Content.displayName;

const AccordionTitle = React.forwardRef(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn('c-accordion-title', 'flex-1 font-bold text-neutral-dark', className)}
    {...props}
  />
));
AccordionTitle.displayName = 'AccordionTitle';

const AccordionSubtitle = React.forwardRef(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn('c-accordion-subtitle', 'shrink-0 text-neutral', className)}
    {...props}
  />
));
AccordionSubtitle.displayName = 'AccordionSubtitle';

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent, AccordionTitle, AccordionSubtitle };
